module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-ford.937ca0c7.jpg";